import React, { useCallback, useEffect, useRef, useMemo } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import LogUtils from "../../../libs/LogUtils";
import {
  serviceCreateCity,
  serviceUpdateCity,
  serviceDeleteCity,
  serviceCityIsExist
} from "../../../services/City.service";
import useDebounce from "../../../hooks/DebounceHook";
import debounce from "lodash.debounce";
import { useDispatch, useSelector } from "react-redux";
import { actionFetchCity } from "../../../actions/City.action";
function useCityCreateHook({ isOpen, handleToggle, editData,handleSideToggle,  isSidePanel , id}) {
  const initialForm = {
    icon: "",
    name: "",
    status: true,
    is_popular: true,
  };

  const [form, setForm] = useState({ ...initialForm });
  const [errorData, setErrorData] = useState({});
  const [images, setImages] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resData, setResData] = useState([]);
  const [image, setImage] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const dispatch = useDispatch();
  const [listData, setListData] = useState({
    ROLES: [],
    UNITS: [],
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { id: stateId } = useParams();
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.state);
  //console.log('state_id:', state_id);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setForm({ ...initialForm });
      setResData([]);
      setIsSubmitting(false);
      setErrorData({});
    }
  }, [isOpen]);

  // console.log("id before useEffect: ", id);
  useEffect(() => {
    if (editData?.id) {
      setForm({
        ...form,
        name: editData?.name,
        is_popular: editData?.is_popular ? true : false,
        status: editData?.status === "ACTIVE",
        icon_url:editData?.icon,
        icon:null,
      });
      setImage(editData?.icon || null);

    }
  }, [editData?.id]);
  console.log(image, ">>>image");

  const checkFormValidation = useCallback(() => {
    const errors = {};
    let required = ["name"];
    // if(form?.is_popular){
    //   required.push("icon")
    // }
    if (form?.is_popular && !form?.icon && !form?.icon_url) {
      required.push("icon")
    }
    required.forEach((val) => {
      if (
        (!form?.[val] && parseInt(form?.[val]) != 0) ||
        (Array.isArray(form?.[val]) && form?.[val]?.length === 0)
      ) {
        errors[val] = true;
      }
    });
    if (form?.name?.length < 2) {
      errors["name"] = true;
    }
    if (form?.code?.length < 2) {
      errors["code"] = true;
    }
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (value, fieldName) => {
      let shouldRemoveError = true;
      const updatedForm = { ...form };

      if (fieldName === "is_popular") {
        updatedForm.is_popular = value;
      } else {
        updatedForm[fieldName] = value;
      }

      setForm(updatedForm);
      // if (fieldName === "name") {
      //   checkCityExistDebouncer(updatedForm);
      // }
      if (["name"]?.includes(fieldName)) {
        checkCityExistDebouncer(updatedForm);
      }
      shouldRemoveError && removeError(fieldName);

      
    },
    [removeError, form, setForm]
  );
 

  const submitToServer = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);

      const errors = {};
      if (!form.name.trim()) {
        errors.name = "City Name is required";
      }

      if (Object.keys(errors).length > 0) {
        setErrorData(errors);
        setIsSubmitting(false);
        return;
      }
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        // if (key !== "icon") {
          if (key === "status") {
            formData.append("is_active", form[key] ? true : false);
          } else if (key === "is_popular") {
            formData.append(key, form[key] ? true : false);
          } else if (key !== "icon_url" && form[key]) {
            formData.append(key, form[key]);
          }
        // }
        // if (key !== "icon_url" && form[key]) {
        //   formData.append(key, form[key]);
        // }
      });
      // if (form?.icon) {
      //   formData.append("icon", form?.icon);
      // }
      // if (form?.icon_url) {
      //   formData.append("icon", form?.icon_url);
      // }
      if (stateId) {
        formData.append("state_id", stateId);
      }
      // if (form?.icon_url) {
      //   console.log("object");
      //   formData.append("icon", form?.icon_url);
      // }
      let req;
      console.log("id", editData?.id);
      if (editData?.id) {
        formData.append("id", editData?.id);
        req = serviceUpdateCity(formData);
      } else {
        req = serviceCreateCity(formData);
      }

      req.then((res) => {
        if (!res.error) {
         
          SnackbarUtils.success(editData?.id ? "Updated successfully!" : "Created successfully!");
          setTimeout(() => setSuccessMessage(""), 3000);
          // handleToggle();
          //historyUtils.push("/unit");
          //window.location.reload();
          handleSideToggle();
          dispatch(
            actionFetchCity(
              1,
              {},
              {
                // query: isMountRef.current ? query : null,
                // query_data: isMountRef.current ? queryData : null,
                state_id: id,
              }
            )
          );
        } else {
          SnackbarUtils.error(res.message);
          if (res.message.includes("Name already exists")) {
            setErrorData((prev) => ({ ...prev, name: true }));
          }
          setIsSubmitting(false);
        }
        // setIsSubmitting(false);
      });
    }
  }, [form, isSubmitting, setIsSubmitting, setErrorData, editData]);

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );
  const checkCityExistence = (data) => {
    if (data?.name) {
      let req = serviceCityIsExist({ name: data.name });
      req.then((res) => {
        if (!res.error) {
          const errors = JSON.parse(JSON.stringify(errorData));
          if (res.data.is_exist) {
            errors.name = true;
            errors["name"] = `City name already exists`;
            setErrorData(errors);
           
          }  
        }
      });
    }
  };
const checkCityExistDebouncer = useMemo(() => {
    return debounce((data) => {
      checkCityExistence(data);
    }, 1000);
  }, [errorData]);

  const handleSubmit = useCallback(
    async (status) => {
      const errors = checkFormValidation();
      LogUtils.log("errors==>", errors);
      if (Object.keys(errors)?.length > 0) {
        setErrorData(errors);
        return true;
      }
      submitToServer(status);
    },
    [checkFormValidation, setErrorData, form, submitToServer]
  );

  

  return {
    form,
    errorData,
    listData,
    resData,
    changeTextData,
    onBlurHandler,
    removeError,
    handleSubmit,
    isSubmitting,
    images,
   
    editData,
    openDialog,
    closeDialog,
    isDialogOpen,
    image,
    stateId
  };
}

export default useCityCreateHook;
